import React from 'react'

import { ThemeProvider } from '@mui/material/styles';
import Theme from "./theme"

import { ReducedMotion } from './reduce-motion'
import { GlobalCssPriority } from './global-css-priority'

export function ThemeWrap({ children = null }) {
  // const innerTheme = responsiveFontSizes(theme)
  return (
    <GlobalCssPriority>
      <ThemeProvider theme={Theme}>
        <ReducedMotion>{children}</ReducedMotion>
      </ThemeProvider>
    </GlobalCssPriority>
  )
}

export default ThemeWrap
